/**
 * Builds the auto-generated inquiry summary and a click-to-chat WhatsApp URL.
 * Business number is configurable via REACT_APP_WHATSAPP_NUMBER (intl, no +).
 */
const BUSINESS_NUMBER =
  process.env.REACT_APP_WHATSAPP_NUMBER || '919444150808';

const inr = (n) =>
  typeof n === 'number' ? `₹${n.toLocaleString('en-IN')}` : n || '—';

export function buildInquirySummary({ pkg, addOns = [], lead = {}, showPricing = true }) {
  const lines = [];
  lines.push('🎉 *New Event Inquiry — Event Story*');
  lines.push('');
  if (pkg) {
    lines.push(`📦 *Package:* ${pkg.title}${pkg.category ? ` (${pkg.category})` : ''}`);
    if (showPricing) lines.push(`💰 *Base Price:* ${inr(pkg.price)}`);
  }
  if (addOns.length) {
    lines.push('');
    lines.push('➕ *Add-ons:*');
    addOns.forEach((a) =>
      lines.push(showPricing ? `   • ${a.title} — ${inr(a.price)}` : `   • ${a.title}`)
    );
  }
  if (showPricing) {
    const total = (pkg?.price || 0) + addOns.reduce((s, a) => s + (a.price || 0), 0);
    lines.push('');
    lines.push(`🧾 *Estimated Total:* ${inr(total)}`);
  }
  lines.push('');
  lines.push('👤 *Customer Details*');
  if (lead.name) lines.push(`   • Name: ${lead.name}`);
  if (lead.mobile) lines.push(`   • Mobile: ${lead.mobile}`);
  if (lead.email) lines.push(`   • Email: ${lead.email}`);
  if (lead.eventDate) lines.push(`   • Event Date: ${lead.eventDate}`);
  if (lead.location) lines.push(`   • Location: ${lead.location}`);
  if (lead.notes) lines.push(`   • Notes: ${lead.notes}`);
  return lines.join('\n');
}

export function buildWhatsAppUrl(summary, number = BUSINESS_NUMBER) {
  return `https://wa.me/${number}?text=${encodeURIComponent(summary)}`;
}

export { inr as formatINR };
